import { motion, useReducedMotion } from "framer-motion";

const NODES = [
  { cx: 10, cy: 20 }, { cx: 26, cy: 58 }, { cx: 42, cy: 28 }, { cx: 55, cy: 66 },
  { cx: 70, cy: 38 }, { cx: 84, cy: 20 }, { cx: 92, cy: 54 }, { cx: 18, cy: 82 },
  { cx: 48, cy: 88 }, { cx: 76, cy: 80 }, { cx: 34, cy: 44 }, { cx: 63, cy: 14 },
];
const LINKS = [
  [0, 2], [2, 4], [4, 5], [5, 11], [1, 3], [3, 4], [1, 7], [3, 8],
  [4, 6], [6, 9], [2, 10], [10, 1], [11, 4], [8, 9], [0, 10],
];

// Static faint intelligence lattice — gives depth without any continuous motion behind text.
function NodeLattice() {
  return (
    <svg className="absolute inset-0 w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden>
      {LINKS.map(([a, b], i) => (
        <line key={i} x1={NODES[a].cx} y1={NODES[a].cy} x2={NODES[b].cx} y2={NODES[b].cy}
          stroke="#F97316" strokeWidth="0.1" strokeOpacity="0.14" />
      ))}
      {NODES.map((n, i) => (
        <circle key={i} cx={n.cx} cy={n.cy} r="0.7" fill="#F97316" fillOpacity="0.3" />
      ))}
    </svg>
  );
}

// Calm ambient backdrop: static grid + static depth glows + static lattice. One optional slow light-sweep.
// No panning, no drifting orbs, no perpetual pulsing (honours the "settle, don't loop" motion law).
export function AmbientBackground({ className = "", showScan = true, showGrid = true }) {
  const reduce = useReducedMotion();
  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} aria-hidden>
      {showGrid && (
        <div
          className="absolute inset-0 opacity-[0.13]"
          style={{
            backgroundImage:
              "linear-gradient(rgba(249,115,22,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(249,115,22,0.4) 1px, transparent 1px)",
            backgroundSize: "46px 46px",
            maskImage: "radial-gradient(140% 95% at 45% 12%, #000 32%, transparent 82%)",
            WebkitMaskImage: "radial-gradient(140% 95% at 45% 12%, #000 32%, transparent 82%)",
          }}
        />
      )}
      {/* static depth glows (no movement) */}
      <div className="absolute top-[-10%] left-[20%] w-[46rem] h-[46rem] rounded-full bg-donkey-orange/10 blur-[140px]" />
      <div className="absolute -top-24 right-[8%] w-[40rem] h-[40rem] rounded-full bg-donkey-orange/10 blur-[130px]" />
      <div className="absolute bottom-[-14%] left-[2%] w-[32rem] h-[32rem] rounded-full bg-donkey-deeporange/10 blur-[130px]" />
      <div className="absolute inset-0 opacity-60"><NodeLattice /></div>
      {/* a single, slow, subtle light-sweep (a glint, not constant motion) */}
      {showScan && !reduce && (
        <motion.div
          className="absolute left-0 right-0 h-px bg-gradient-to-r from-transparent via-donkey-orange/35 to-transparent"
          animate={{ top: ["-2%", "102%"] }}
          transition={{ duration: 12, repeat: Infinity, ease: "linear", repeatDelay: 6 }}
        />
      )}
    </div>
  );
}

export default AmbientBackground;
